import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Flex } from '@theme-ui/components';
import { css } from '@emotion/react';

import { H2 } from '@app/components/typography';
import type { CheckoutSuccessQuery_magento2_customer } from '@app/pages/Checkout/Success/__generated__/CheckoutSuccessQuery';
import fontSizes from '@app/styles/theme/fontSizes';

import successIcon from '../assets/success.svg';
import messages from '../Success.messages';

const OrderStatus: FC<{
  customer?: CheckoutSuccessQuery_magento2_customer;
}> = ({ customer }) => (
  <>
    <H2 as="h1" data-testid="success-thank-you">
      <FormattedMessage
        {...messages.thankYouTitle}
        values={{ name: customer?.firstname }}
      />
    </H2>

    <Flex mt={20}>
      <Box mr={10} sx={{ minWidth: '35px' }}>
        <img src={successIcon} alt="" />
      </Box>

      <Box>
        <p
          css={css`
            font-size: ${fontSizes[2]};
            margin-top: 0;
          `}
        >
          <FormattedMessage {...messages.successMessage} />
        </p>

        <p
          css={css`
            font-size: ${fontSizes[2]};
            margin-bottom: 0;
          `}
        >
          <span data-testid="success-customer-email">
            <FormattedMessage
              {...messages.successEmail}
              values={{ email: customer?.email }}
            />
          </span>
        </p>
      </Box>
    </Flex>
  </>
);

export default OrderStatus;
